import { buttonCoreDriverFactory } from '../Button/ButtonCore/ButtonCore.uni.driver';
import {
  isElementFocused,
  baseUniDriverFactory,
} from '../test-utils/utils/unidriver';

export const iconButtonDriverFactory = base => {
  const buttonDriver = buttonCoreDriverFactory(base);

  return {
    ...baseUniDriverFactory(base),
    /** returns true if button disabled */
    isButtonDisabled: buttonDriver.isButtonDisabled,
    /**
     * Checks whether button is focused
     * @returns {Promise<boolean>}
     */
    isFocused: async () => isElementFocused(base),
  };
};
